export const increaseTotal = (increaseAmount) => dispatch => {
  return dispatch({ type: "INCREASE_TOTAL", payload: increaseAmount })
};